export { clearFullStory, initializeFullStory, identifyFullStoryUser, sendFSEvent } from './fullstory.utils';
